import { Breadcrumb, BreadcrumbItem } from '@doda/io-react/pc';
import { BreadcrumbItemTop } from 'components/BreadcrumbItemTop';
import { FC } from 'react';
import { TopicJob } from '@doda/pc/src/pages/DodaFront/View/FeaturedJobList/types';
import { makeStaticUrl } from '@doda/common/src/logics/staticUrl';
import { DODA_SITE_URL } from '@doda/common/src/constants/urls';

/**
 * BreadcrumbListコンポーネントのプロパティを定義するインターフェース
 */
interface BreadcrumbListProps {
  /** タイトルテキスト */
  titleText: TopicJob['title'];
  /** 特集ID */
  featuredId: string;
  /** 現在のページ番号 */
  currentPage: number;
}

const JAVA_TOPIC = 'A2000015477';
const PHP_TOPIC = 'A2000015478';

/**
 * BreadcrumbListコンポーネント
 *
 * @param {BreadcrumbListProps} props - コンポーネントのプロパティ
 * @returns {JSX.Element} JSX要素
 */
export const BreadcrumbList: FC<BreadcrumbListProps> = ({
  titleText,
  featuredId,
  currentPage,
}) => {
  const isEngineerTopic = featuredId === JAVA_TOPIC || featuredId === PHP_TOPIC;
  const url = makeStaticUrl({ fid: featuredId }, DODA_SITE_URL.featuredJobList);
  const isSecondPageOrLater = currentPage >= 2;
  const topicTitle = titleText || '求人特集';

  return (
    <Breadcrumb>
      <BreadcrumbItemTop />
      {isEngineerTopic && (
        <BreadcrumbItem href="/engineer/">
          転職・求人dodaエンジニアITトップ
        </BreadcrumbItem>
      )}
      {isSecondPageOrLater ? (
        <>
          <BreadcrumbItem href={url}>{topicTitle}</BreadcrumbItem>
          <BreadcrumbItem>{currentPage}ページ</BreadcrumbItem>
        </>
      ) : (
        <BreadcrumbItem>{topicTitle}</BreadcrumbItem>
      )}
    </Breadcrumb>
  );
};
